import type { PedidoEndereco } from './api';

// Perfil LOCAL do cliente (agilidade SEM login): lembra nome/telefone/endereço/entrega no PRÓPRIO
// dispositivo para pré-preencher o checkout na próxima visita, para o público que tem dificuldade em
// redigitar tudo. NÃO é autenticação — é conveniência local, por loja (chave por slug), no espírito da loja
// online do Vendeon (cliente sempre anônimo). Tolerante a storage indisponível (modo privado/quota) e a JSON
// corrompido: nunca lança — o pior caso é não lembrar.

export interface ClientePerfil {
  nome: string;
  phone: string;
  fulfillment: 'ENTREGA' | 'RETIRADA';
  address: PedidoEndereco & { complemento: string };
}

const PREFIXO = 'vitto:cardapio:perfil:';

function chave(slug: string): string {
  return PREFIXO + slug;
}

function enderecoVazio(): PedidoEndereco & { complemento: string } {
  return { cep: '', logradouro: '', numero: '', bairro: '', cidade: '', uf: '', complemento: '' };
}

export function lerPerfil(slug: string): ClientePerfil | null {
  try {
    const raw = localStorage.getItem(chave(slug));
    if (!raw) return null;
    const p = JSON.parse(raw) as Partial<ClientePerfil> | null;
    if (!p || typeof p.nome !== 'string' || typeof p.phone !== 'string') return null;
    const a = (p.address ?? {}) as Partial<PedidoEndereco & { complemento: string }>;
    return {
      nome: p.nome,
      phone: p.phone,
      fulfillment: p.fulfillment === 'RETIRADA' ? 'RETIRADA' : 'ENTREGA',
      address: {
        cep: typeof a.cep === 'string' ? a.cep : '',
        logradouro: typeof a.logradouro === 'string' ? a.logradouro : '',
        // numero/uf (10/09) — sem lembrar o NÚMERO, o cliente recorrente redigitava justamente o único campo
        // que a busca de CEP não preenche, que é o trabalho que o dono pediu para poupar. Registro antigo
        // (gravado antes destes campos) lê como vazio, sem quebrar o pré-preenchimento do resto.
        numero: typeof a.numero === 'string' ? a.numero : '',
        bairro: typeof a.bairro === 'string' ? a.bairro : '',
        cidade: typeof a.cidade === 'string' ? a.cidade : '',
        uf: typeof a.uf === 'string' ? a.uf : '',
        complemento: typeof a.complemento === 'string' ? a.complemento : '',
      },
    };
  } catch {
    return null;
  }
}

export function salvarPerfil(slug: string, perfil: ClientePerfil): void {
  try {
    localStorage.setItem(chave(slug), JSON.stringify(perfil));
  } catch {
    /* storage indisponível/quota — segue sem lembrar (nunca quebra o pedido) */
  }
}

export function limparPerfil(slug: string): void {
  try {
    localStorage.removeItem(chave(slug));
  } catch {
    /* ignore */
  }
}

export { enderecoVazio };
